import React from "react";
import { Star } from "lucide-react";
import { testimonials } from "@/data/metiers/garagisteData";

const GaragisteTestimonials = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6 text-fabre-gray">
              Ce que disent nos clients garagistes
            </h2>
            <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-8 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gradient-to-br from-fabre-lightgreen to-white rounded-2xl shadow-lg p-8 border border-fabre-green/20">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                  ))}
                </div>
                <p className="text-gray-700 italic mb-6 leading-relaxed">
                  "{testimonial.content}"
                </p>
                <div className="border-t border-fabre-green/20 pt-4">
                  <div className="font-bold text-fabre-gray">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.company}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GaragisteTestimonials;